import { Capacitor } from '@capacitor/core';

// True only when running inside the native iOS/Android Capacitor shell.
export const isNativePlatform = () => Capacitor.isNativePlatform();

// 'ios' | 'android' | 'web'
export const getPlatform = () => Capacitor.getPlatform();

// Check if a specific Capacitor plugin is available at runtime.
export const isPluginAvailable = (name) => Capacitor.isPluginAvailable(name);
